import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Form, InputGroup } from 'react-bootstrap';
import { FaSearch, FaRobot, FaSignInAlt } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            const isVisible = prevScrollPos > currentScrollPos || currentScrollPos < 10;

            setPrevScrollPos(currentScrollPos);
            setVisible(isVisible);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos]);

    const handleLogin = () => {
        navigate('/signup');
    };

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <Navbar 
            expand="lg" 
            className={`custom-navbar sticky-top ${visible ? 'navbar-visible' : 'navbar-hidden'}`}
        >
            <Container>
                <NavLink to="/" className="navbar-brand d-flex align-items-center">
                    <FaRobot className="brand-icon me-2" />
                    <span className="brand-text">Agenti</span>
                </NavLink>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink 
                            to="/" 
                            className={({isActive}) => 
                                `nav-link nav-link-custom ${isActive ? 'active' : ''}`
                            }
                            end
                        >
                            Home
                        </NavLink>
                        <NavLink 
                            to="/pricing" 
                            className={({isActive}) => 
                                `nav-link nav-link-custom ${isActive ? 'active' : ''}`
                            }
                        >
                            Pricing
                        </NavLink>
                        <NavLink 
                            to="/subscribe" 
                            className={({isActive}) => 
                                `nav-link nav-link-custom ${isActive ? 'active' : ''}`
                            }
                        >
                            📧 Subscribe
                        </NavLink>
                    </Nav>
                    <Form className="d-flex mt-2 mt-lg-0">
                        <InputGroup>
                            <InputGroup.Text className="search-icon">
                                <FaSearch />
                            </InputGroup.Text>
                            <Form.Control
                                type="search"
                                placeholder="Search for AI agents..."
                                className="search-input"
                            />
                        </InputGroup>
                    </Form>
                    {user ? (
                        <div className="d-flex align-items-center ms-2">
                            <span className="me-2 text-muted">
                                Hi, {user.name || user.email}
                            </span>
                            <Button variant="outline-secondary" onClick={handleLogout}>
                                Logout
                            </Button>
                        </div>
                    ) : (
                        <Button variant="primary" onClick={handleLogin} className="ms-2">
                            <FaSignInAlt className="me-1" />
                            Login
                        </Button>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation; 